@if (visible) {
  <div class="modal-backdrop fade show" (click)="close()"></div>
  <div class="modal fade show d-block modal-component" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
      <div class="modal-content">
        <ng-content></ng-content>
        @if (closable) {
          <button type="button" (click)="close()" [attr.aria-label]="'common.close' | translate" class="dialog__close-btn text-secondary h4">
            <i [class]="'common.close' | nogoshIcon"><span class="sr-only">{{ 'accessibility.closeDialog' | translate }}</span></i>
          </button>
        }
      </div>
    </div>
  </div>
}
